import { render, staticRenderFns } from "./CategorizedProducts.vue?vue&type=template&id=67ed1ad8&"
import script from "./CategorizedProducts.vue?vue&type=script&lang=js&"
export * from "./CategorizedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports